import React, { useEffect } from 'react'
import { Link } from 'react-router-dom'
import cn from 'classnames'

import * as product from 'constants/product-types'

import useValidateProductsFlags from 'hooks/useValidateProductsFlags'

import ProductsClose from 'assets/svg/products-close.svg'

import StringFormat from 'utils/StringFormat'

import './ProductsMenu.scss'
import { FLAGS, useFeatureFlag } from 'components/ff4j'
import { PodTiffany } from 'assets/img/cards'

const PodAndTudo = [product.TUDO, product.POD]

const ProductsMenu = ({ products, bank, mobile, onClick }) => {
    useEffect(() => {
        if (mobile) {
            document.body.classList.add('overflow-hidden')

            return () => document.body.classList.remove('overflow-hidden')
        }
    }, [])

    const productsEnabled = useValidateProductsFlags(
        products,
        StringFormat.bankAbbreviation(bank)
    )

    const productsList = productsEnabled.filter((p) => p.vendible)

    const segregecaoEnabled = useFeatureFlag(FLAGS.SEGREGACAO_CNPJ)

    const getImage = (product) => {
        const image = StringFormat.renderAlternateImg(+product.code)

        if (segregecaoEnabled && product.productType === 'POD') {
            return PodTiffany
        }

        return image
    }

    return (
        <div className={cn('products-menu')}>
            <svg
                width="30"
                height="13"
                viewBox="0 0 30 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
            >
                <g filter="url(#filter0_d)">
                    <path
                        fillRule="evenodd"
                        clipRule="evenodd"
                        d="M15 2L29 13H1L15 2Z"
                        fill="white"
                    />
                </g>
                <defs>
                    <filter
                        id="filter0_d"
                        x="0"
                        y="0"
                        width="30"
                        height="13"
                        filterUnits="userSpaceOnUse"
                        colorInterpolationFilters="sRGB"
                    >
                        <feFlood floodOpacity="0" result="BackgroundImageFix" />
                        <feColorMatrix
                            in="SourceAlpha"
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
                        />
                        <feOffset dy="-1" />
                        <feGaussianBlur stdDeviation="0.5" />
                        <feColorMatrix
                            type="matrix"
                            values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
                        />
                        <feBlend
                            mode="normal"
                            in2="BackgroundImageFix"
                            result="effect1_dropShadow"
                        />
                        <feBlend
                            mode="normal"
                            in="SourceGraphic"
                            in2="effect1_dropShadow"
                            result="shape"
                        />
                    </filter>
                </defs>
            </svg>
            <div className="products-menu__container">
                <span className="products-menu__title">
                    NOSSOS PRODUTOS
                    <img
                        src={ProductsClose}
                        alt="Fechar modal"
                        onClick={onClick}
                    />
                </span>
                <div className="products-menu__products-list">
                    {productsList.map((product) => (
                        <Link
                            onClick={() => onClick()}
                            key={product.id}
                            to={
                                bank
                                    ? `/${bank}/detalhes/${StringFormat.wcmNameProducts(+product.code)}`
                                    : `/detalhes/${StringFormat.wcmNameProducts(+product.code)}`
                            }
                            className="products-menu__list"
                            id={`productsMenuList${StringFormat.cardKind(+product.code)}`}
                        >
                            <div className="products-menu__products">
                                <div className="products-menu__products-image">
                                    <img
                                        className={cn(
                                            'products-menu__products-mini-card',
                                            {
                                                'mini-card-alelo-tudo-pod':
                                                    PodAndTudo.includes(
                                                        +product.code
                                                    )
                                            }
                                        )}
                                        src={getImage(product)}
                                        alt="Alelo mini card"
                                    />
                                </div>
                                <label className="products-menu__products-description">
                                    {' '}
                                    Alelo{' '}
                                    <strong>
                                        {
                                            StringFormat.nameProducts(
                                                +product.code
                                            ).split(' ')[1]
                                        }
                                    </strong>{' '}
                                </label>
                            </div>
                        </Link>
                    ))}
                    {!bank && (
                        <a
                            href="https://www.alelo.com.br/empresas"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="products-menu__list"
                            id="productsMenuListOtherProducts"
                        >
                            <div className="products-menu__products">
                                <div className="products-menu__products-image">
                                    <img
                                        className="products-menu__products-mini-card"
                                        src={StringFormat.renderAlternateImg()}
                                        alt="Alelo mini card"
                                    />
                                </div>
                                <label className="products-menu__products-description">
                                    <strong>Outros Produtos</strong>
                                </label>
                            </div>
                        </a>
                    )}
                </div>
            </div>
        </div>
    )
}

export default ProductsMenu
